import {offlineDb} from './db';

/**
 * Writes a snapshot from a local applier, keeping the original `cachedAt`. A
 * domain session's staleness is read from one snapshot's `cachedAt`, so a local
 * write must never look like a fresh server fetch.
 */
export const putSnapshotPreservingCachedAt = async (
  sessionId: string,
  key: string,
  data: unknown
): Promise<void> => {
  const existing = await offlineDb.snapshots.get([sessionId, key]);
  await offlineDb.snapshots.put({
    key,
    sessionId,
    data,
    cachedAt: existing?.cachedAt ?? new Date().toISOString(),
  });
};
